import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import * as moment from "moment";
import { ModalViewBaremeDetailComponent } from "src/app/shared/components/modal-view-bareme-detail/modal-view-bareme-detail.component";


@Component({
  selector: 'app-modal-view-beneficiaire-detail',
  templateUrl: './modal-view-beneficiaire-detail.component.html',
  styleUrls: ['./modal-view-beneficiaire-detail.component.scss']
})
export class ModalViewBeneficiaireDetailComponent implements OnInit {

  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  // modalRef: BsModalRef;
  itemBeneficiaire: any = {};
  itemsFiliale: any;
  imageDisplay=''

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    setTimeout(() => {
      if (this.currentData) {
        this.itemBeneficiaire = {...this.currentData}
        console.log('this.itemBeneficiaire: ',this.itemBeneficiaire)
        // this.getitemBeneficiaire(this.currentData.id);
      }
    }, 50);
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }
  getAge() {
    if (this.itemBeneficiaire.date_naissance) {
      let age = moment().diff(this.itemBeneficiaire.date_naissance, "years");
      return age;
    }
    return 0;
  }
  

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalPrestataireReseau() {
    if(!this.itemBeneficiaire.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.bsModalRef = this.modalService.show(modal, {
      id: 545854500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemBeneficiaire.reseau_de_soin_id,reseau_de_soin_libelle:this.itemBeneficiaire.reseau_de_soin_libelle}
    if (data) this.bsModalRef.content.currentData = data;
    this.bsModalRef.onHide.subscribe((res) => {
    });
  
  
  }
  openModalDetailBareme(){}

  ngOnInit() {
    this.getItemsFiliale();
  }

}
